<template>
    <div class="charge-register max-content">
        <!-- 步骤条 -->
        <div class="steps">
            <div :class="active >= 1 ? 'active' : ''"><van-icon v-if="active > 1" name="checked" color="#901D22" /><span
                    v-else>1</span>填写信息</div>
            <van-icon name="play" size="18" color="#d8d8d8" />
            <div :class="active >= 2 ? 'active' : ''"><van-icon v-if="active > 2" name="checked" color="#901D22" /><span
                    v-else>2</span>{{ type == 1 ? '扫码付费' : '银行转账' }}</div>
            <van-icon name="play" size="18" color="#d8d8d8" />
            <div :class="active >= 3 ? 'active' : ''"><van-icon v-if="active > 3" name="checked" color="#901D22" /><span
                    v-else>3</span>{{ type == 1 ? '开票完成注册' : '汇款凭证和开票' }}</div>
        </div>
        <!--  填写信息 -->
        <div class="form" v-if="active == 1">
            <h4 class="htitle">填写<span>参会人信息</span></h4>
            <van-form>
                <van-cell-group :border="false">
                    <van-field v-model="name" :border="false" label="姓名" placeholder="请填写姓名" label-class="label"
                        :rules="[{ message: '请输入正确内容' }]" />
                    <van-field v-model="mobile" :border="false" label="手机号" placeholder="请填写手机号" label-class="label"
                        :rules="[{ pattern: mobileReg, message: '请输入正确内容' }]" />
                    <van-field v-if="meeting_id==819" v-model="email" :border="false" label="邮箱" placeholder="请填写邮箱" label-class="label"
                        :rules="[{ pattern: emailReg, message: '请输入正确内容' }]" />
                    <van-field v-model="idCard" :border="false" label="身份证号" placeholder="请填写身份证号" label-class="label" />
                    <van-field v-model="age" :border="false" label="年龄" placeholder="请填写年龄" label-class="label" />
                    <van-field v-model="sex" :border="false" label="性别" placeholder="请选择性别" label-class="label" readonly
                        clickable @click="showPicker('sex')" right-icon="arrow" />
                    <van-field v-if="meeting_id!=819" v-model="education" :border="false" label="学历" placeholder="请选择学历" label-class="label"
                        readonly clickable @click="showPicker('edu')" right-icon="arrow" />
                    <van-field v-if="meeting_id == 819" name="basic_level" :border="false" label="是否来自基层" label-class="label">
                        <template #input>
                            <van-radio-group v-model="basic_level" direction="horizontal">
                                <van-radio name="是" checked-color="#901D22">是</van-radio>
                                <van-radio name="否" checked-color="#901D22">否</van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>
                    <van-field v-model="job_name" :border="false" label="职称" placeholder="请选择职称" label-class="label"
                        readonly clickable @click="showPicker('job_name')" right-icon="arrow" />
                    <van-field v-model="company" :border="false" label="工作单位" placeholder="请填写单位标准全称"
                        label-class="label" />
                    <van-field v-model="address" label="单位所在地" label-class="label" placeholder="请选择单位所在地" readonly
                        clickable @click="showPicker('address')" right-icon="arrow" />
                </van-cell-group>
                <p style="font-size: 12px;color: #666;">因发票的抬头需和参会人单位保持一致，请务必正确填写工作单位全称。</p>
            </van-form>
        </div>
        <!-- 扫码付费 -->
        <div class="scan" v-if="active == 2">
            <h4 class="htitle">注册<span>收费</span></h4>
            <p class="info">本次<span style="color: #901D22;">付费金额为人民币1000元整</span> ，请严格按照金额付费并截图支付记录，感谢您的支持，协会拥有最终解释权。
            </p>
            <div class="money">
                <div>{{ pay[0] }}</div>
            </div>  
            <div v-if="meeting_id == 508 || meeting_id == 627 || meeting_id == 816" style="width: 100%;">
                <div class="pay-qrcode" v-if="meeting_id == 508">
                    <img src="//cdn.edstatic.com/203012120000/9e23a19a897a31b5f217553c68c4999a/2025/02/22fb46d4-4daa-4e23-8028-7369e9473b4d.png"
                        alt="">
                    <p style="color:#000;padding: 10px 0;">2024年乳房重建论坛会议</p>
                    <p>长按识别付款</p>
                </div>
                <div class="pay-qrcode" v-if="meeting_id == 627">
                    <img src="//cdn.edstatic.com/203012120000/49c17c2e58466b59a75fb2cf7a0a52f8/2025/09/7e32a66f-f958-4a34-9f85-2626ee6e8415.png"
                        alt="">
                    <p style="color:#000;padding: 10px 0;">2025年乳房重建论坛会议</p>
                    <p>长按识别付款</p>
                </div>
                <div class="pay-qrcode" v-if="meeting_id == 816">
                    <img src="//cdn.edstatic.com/203012120000/6326324f59028f88de3ef2c5e0516022/2026/09/e6189d55-51df-4979-8781-4d1bc91b3e0f.webp"
                        alt="">
                    <p style="color:#000;padding: 10px 0;">2026乳房重建论坛会议</p>
                    <p>长按识别付款</p>
                </div>
                <div class="tip-msg">
                    <p style="color: #901D22;font-weight: 500;">支付注意事项：</p>
                    <p>1.支付时<span style="color: #901D22;">请备注：参会人姓名</span>。供核对； </p>
                    <p>2.支付成功后，需要上传支付记录截图方为注册成功。 （下载APP【微店】/搜索小程序【微店买买】-【我的】-【我的订单】-【查看更多】-【点击对应订单】，截图需要露出订单号）</p>
                </div>
                <div class="tip-msg">
                    <p style="color: #901D22;">支付方式</p>
                    <p>微信扫码支付（不支持信用卡）</p>
                </div>
            </div>
            <div v-else>
                <div v-if="type == 1" style="padding-bottom: 30%;">
                    <div class="pay-qrcode" v-if="qrcode_url">
                        <img :src="qrcode_url" alt="">
                        <p>长按识别付款</p>
                    </div>
                    <div v-else>
                        <div class="tip-msg" v-if="meeting_id == 819">
                            <p style="color: #901D22;font-weight: 500;">支付注意事项：</p>
                            <!-- <p>1.支付时请备注<span style="color: #901D22;">“姓名+2026年SIBCS”</span>。供核对； </p> -->
                            <p>支付成功后，可截图保留支付记录作为后期核销凭证。</p>
                        </div>
                        <div class="tip-msg" v-else>
                            <p style="color: #901D22;font-weight: 500;">支付注意事项：</p>
                            <!-- <p>1.支付时<span style="color: #901D22;">请备注：参会人姓名</span>。供核对； </p> -->
                            <p>1.支付成功后，可截图保留支付记录作为后期核销凭证。</p>
                        </div>
                        <div class="tip-msg">
                            <p style="color: #901D22;">支付方式</p>
                            <p>微信支付</p>
                        </div>
                    </div>

                </div>


                <div v-else>
                    <div class="tip-msg" v-if="meeting_id == 819">
                            <p style="color: #901D22;font-weight: 500;">支付注意事项：</p>
                            <p>1.支付时请备注<span style="color: #901D22;">“姓名+2026年SIBCS”</span>。供核对； </p>
                            <p>2.支付成功后，可截图保留支付记录作为后期核销凭证。</p>
                        </div>
                    <div class="tip-msg" v-else>
                        <p style="color: #901D22;font-weight: 500;">支付注意事项：</p>
                        <p>1.转账时<span style="color: #901D22;">请务必备注：参会人姓名+2025SIBCS</span>。供核对； </p>
                        <p>2.支付成功后，需要上传支付记录截图方为注册成功。</p>
                    </div>
                    <h4 class="htitle">汇款<span>信息</span></h4>

                    <div class="remit-info">
                        <div>
                            <span>单位名称</span>
                            <p>上海市抗癌协会</p>
                        </div>
                        <div>
                            <span>银行账户</span>
                            <p>1001 2391 0901 4408 593</p>
                        </div>
                        <div>
                            <span>开户行</span>
                            <p>中国工商银行股份有限公司上海市东安路支行</p>
                        </div>
                    </div>
                </div>
            </div>


        </div>
        <!-- 开票 -->
        <div class="invoices " v-if="active >= 3">
            <div v-if="type == 2 || meeting_id == 508 || meeting_id == 627 || meeting_id == 816"
                style="border-bottom: 1px solid #eee;">
                <h4 class="htitle">提交<span>支付订单截图</span></h4>
                <!-- <p style="color: #901D22;margin-bottom: 20px;font-size: 13px;">截图中需要包含订单号</p> -->
                <van-field name="uploader">
                    <template #input>
                        <van-uploader v-model="images" :after-read="uploadImg" :before-delete="deleteImg" />
                    </template>
                </van-field>
            </div>
            <div class="form">
                <h4 class="htitle">开票<span>信息</span></h4>
                <van-form>
                    <van-cell-group :border="false">
                        <van-field v-model="voucher_info.title" :border="false" label="开票抬头" placeholder="请填写开票抬头"
                            label-class="label" :rules="[{ required: true }]" required />
                        <van-field v-model="voucher_info.tax_number" :border="false" label="税号" placeholder="请填写税号"
                            :rules="[{ required: true }]" label-class="label" required />
                        <van-field v-model="voucher_info.address" :border="false" label="注册地址" placeholder="请填写注册地址"
                            label-class="label" />
                        <van-field v-model="voucher_info.bank_name" :border="false" label="开户银行" placeholder="请填写开户银行"
                            label-class="label" />
                        <van-field v-model="voucher_info.bank_number" :border="false" label="银行账户" placeholder="请填写银行账户"
                            label-class="label" />
                        <van-field v-model="voucher_info.email" :border="false" label="收票邮箱" placeholder="请填写收票邮箱"
                            label-class="label" :rules="[{ pattern: emailReg, message: '请输入正确内容' }]" required />
                        <van-field v-model="voucher_info.mobile" :border="false" label="收票人电话" placeholder="请填写收票人电话"
                            label-class="label" :rules="[{ pattern: mobileReg, message: '请输入正确内容' }]" required />
                    </van-cell-group>
                </van-form>
            </div>

            <div class="tip-msg">
                <p style="color: #901D22;">开票注意事项：</p>
                <p>1. 请务必填写正确的开票信息：</p>
                <p>（1）企业发票：<span style="color: #901D22;"> 抬头必须为实际参会人单位</span>;</p>
                <p>（2）个人发票：<span style="color: #901D22;"> 抬头必须为实际参会人姓名</span>;</p>
                <p>2.发票为 <span style="color: #901D22;">电子增值税普通发票</span>，请务必填写正确的邮箱以免收不到；</p>
                <p v-if="meeting_id == 508 || meeting_id == 627 || meeting_id == 816 || meeting_id == 819">3.发票将于 <span
                        style="color: #901D22;">会议结束后45个工作日内由【上海抗癌协会】开具</span>。
                </p>
                <p v-else>3.发票将于 <span style="color: #901D22;">会议结束后45个工作日内开具</span>。</p>
            </div>
        </div>
        <!-- 按钮 -->
        <div class="btns">
            <div v-if="active == 1"
                :style="meeting_id == 508 || meeting_id == 627 || meeting_id == 816 ? { margin: '0 auto' } : ''"
                :class="!isFormComplete && active == 1 ? 'noEnd' : ''"
                @click="next">
                下一步</div>
            <div v-if="active == 2 && type == 1 && qrcode_url" @click="checkPayStatus">下一步</div>
            <div v-if="active == 2 && (meeting_id == 508 || meeting_id == 627 || meeting_id == 816)" @click="initPay"
                style="margin: 0 auto;">上传支付凭证
            </div>
            <div v-if="active == 2 && type == 1 && !qrcode_url && meeting_id != 508 && meeting_id != 627 && meeting_id != 816"
                @click="initPay">
                支付</div>
            <div v-if="active == 2 && type == 2 && meeting_id != 508 && meeting_id != 627 && meeting_id != 816"
                @click="active = 3">下一步</div>
            <div v-if="active >= 3" @click="uploadVoucher">完成注册</div>
        </div>
        <van-popup v-model="showPickerPopup" position="bottom">
            <van-picker show-toolbar :columns="columns" @confirm="onConfirmPicker" @cancel="showPickerPopup = false" />
        </van-popup>
    </div>
</template>

<script>
import { MeetingReg, MeetingUploadVoucher, MeetingUploadImg, MeetingRegInfo, MeetingOrderPayment, MeetingPayCheck, PayInfoUpdate } from '@/config/interface.js';
import { Toast, Field, Form, Cell, CellGroup, Picker, Popup, RadioGroup, Radio } from 'vant';
import wx from 'weixin-js-sdk';
import axios from 'axios';
export default {
    components: {
        Field,
        Form,
        Cell,
        CellGroup,
        Picker,
        Popup,
        RadioGroup,
        Radio
    },
    data() {
        return {
            active: 1,
            showMessage: false,
            showNext: false,
            is_finish: 1,
            name: '',
            mobile: '',
            idCard: '',
            job_name: '',
            education: '',
            hospital: '',
            address: '',
            company: '',
            email:'',
            age: '',
            sex: '',
            basic_level: '',
            pattern: /^[1][3,4,5,7,8][0-9]{9}$/,
            mobileReg: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            emailReg: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            pay: ['大会注册 1000元'],
            money: 1000,
            images: [],
            imageArr: [],
            out_trade_no: '',
            qrcode_url: null,
            voucher_info: {
                title: '',
                tax_number: '',
                address: '',
                bank_name: '',
                bank_number: '',
                email: '',
                mobile: ''
            },
            columns: [],
            edu_list: ['高中以下', '中专', '大专', '本科', '硕士', '博士', '其他学历'],
            sex_list: ['男', '女'],
            address_list: ['北京', '天津', '上海', '河北', '山西', '内蒙古', '辽宁', '吉林', '黑龙江', '江苏', '浙江', '安徽', '福建', '江西', '山东', '河南', '湖北', '湖南', '广东', '广西', '海南', '四川', '贵州', '云南', '西藏', '陕西', '甘肃', '青海', '宁夏', '新疆', '新疆兵团', '重庆', '香港', '澳门', '台湾', '其他国家'],
            job_name_list: ['教授', '副教授', '讲师', '研究员', '副研究员', '助理研究员', '主任医师', '副主任医师', '主治医师',
                '主任护师', '副主任护师', '主管护师', '主任药师', '副主任药师', '主管药师', '主任技师', '副主任技师', '主管技师', '主任营养师',
                '副主任营养师', '主管营养师', '高级工程师', '工程师', '医士', '医师', '主治／主管医师', '副主任医师', '主任医师', '药剂士', '药剂师', '主管药师', '副主任药师', '主任药师', '技士', '技师', '主管技师',
                '副主任技师', '主任技师', '检验士', '检验师', '主管检验师', '副主任检验师', '主任检验师', '护士', '护师', '主管护师', '副主任护师', '主任护师', '无职称'],
            job_name_list_819: ['副高及以上', '中级', '初级', '乡村医生'],
            showPickerPopup: false,
            pick_type: '',
            payInfo: {},
            record_id: '',
            // uploader: [{ url: 'https://img01.yzcdn.cn/vant/leaf.jpg' }],
        };
    },
    mounted() {
        this.active = this.$route.query.step ? this.$route.query.step : 1;
        if (this.meeting_id == 508 || this.meeting_id == 627 || this.meeting_id == 816) {
            document.title = "线上支付";
            this.pay = ['大会注册 1000元']

        } else {
            document.title = this.$route.query.type == 1 ? '线上支付' : "公对公转账";
            if (this.$route.query.type == 2) {
                this.pay = ['大会注册 1000元', '护理注册 500元']
            }
        }
        if (this.$route.query.reg_id) {
            this.reg_id = this.$route.query.reg_id;
            this.active = 3;
        }
        this.getDetail();

    },
    computed: {
        meeting_id() {
            return this.$route.query.meeting_id ? this.$route.query.meeting_id : (this.$route.query.id ? this.$route.query.id : this.$route.query.MT_id);
        },
        type() {
            //	1线上2线下
            return this.$route.query.type ? this.$route.query.type : 1;
        },
        // 819：校验邮箱、是否基层；其他会议：校验学历
        isFormComplete() {
            const base = this.name && this.mobile && this.job_name && this.company && this.idCard && this.address && this.age && this.sex;
            if (this.meeting_id == 819) {
                return !!(base && this.email && this.basic_level);
            }
            return !!(base && this.education);
        },
    },
    methods: {

        getDetail() {
            const url = MeetingRegInfo;
            let params = {
                meeting_id: this.meeting_id
            };
            if (this.$route.query.reg_id) {
                params.reg_id = this.$route.query.reg_id;
            }
            const method = "get";
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0 && res.data) {
                        this.out_trade_no = res.data.out_trade_no
                        if (this.$route.query.isNew == 1) {
                            this.active = 1
                        } else {
                            if (this.$route.query.reg_id && res.data.invoiceInfo) {
                                this.active = 3;
                                this.voucher_info.title = res.data.invoiceInfo.title;
                                this.voucher_info.tax_number = res.data.invoiceInfo.tax_number;
                                this.voucher_info.address = res.data.invoiceInfo.address;
                                this.voucher_info.bank_name = res.data.invoiceInfo.bank_name;
                                this.voucher_info.bank_number = res.data.invoiceInfo.bank_number;
                                this.voucher_info.email = res.data.invoiceInfo.email;
                                this.voucher_info.mobile = res.data.invoiceInfo.mobile;
                                this.imageArr = res.data.pay_voucher;
                                for (var i = 0; i < res.data.pay_voucher.length; i++) {
                                    this.images.push({
                                        url: res.data.pay_voucher[i]
                                    })
                                }
                            }
                            else {
                                this.active = res.data.step

                            }

                        }

                    }
                })
        },
        getPayInfoList() {

        },        //下一步
        next() {
            console.log(this.active)
            if (this.active == 1) {
                if (!this.isFormComplete) {
                    Toast('请填写完整的注册信息')
                } else {
                    common.confirm('提示', '注册信息一旦提交无法修改，是否确认下一步？', () => {
                        this.uploadInfo()
                        this.showNext = true
                    })

                }
            } else if (this.active == 2) {
                this.active = 3
                this.is_finish = 2
            }
        },
        //上一步
        last() {
            if (this.active >= 3) {
                this.active = 2
            } else {
                this.$router.go(-1)
            }
        },
        //选择器
        showPicker(type) {
            if (type == 'sex') {
                this.columns = this.sex_list
            } else if (type == 'edu') {
                this.columns = this.edu_list
            } else if (type == 'job_name') {
                if(this.meeting_id == 819){
                    this.columns = this.job_name_list_819
                }else{
                    this.columns = this.job_name_list
                }
            } else if (type == 'address') {
                this.columns = this.address_list
            }
            this.pick_type = type
            this.showPickerPopup = true
        },
        //确认
        onConfirmPicker(value) {
            let type = this.pick_type
            console.log(type)

            if (type == 'sex') {
                this.sex = value
            } else if (type == 'edu') {
                this.education = value
            } else if (type == 'job_name') {
                this.job_name = value
            } else if (type == 'address') {
                this.address = value
            }
            this.showPickerPopup = false
        },
        //提交注册信息
        uploadInfo() {

            const url = MeetingReg;
            let params = {
                type_id: this.type,
                meeting_id: this.meeting_id,
                username: this.name,
                mobile: this.mobile,
                idcard_number: this.idCard,
                job_name: this.job_name,
                company: this.company,
                age: this.age,
                sex: this.sex,
                address: this.address,
            }
            if (this.meeting_id == 819) {
                params.email = this.email
                params.basic_level = this.basic_level
            } else {
                params.education = this.education
            }
            const method = "POST";
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        // Toast('提交成功')
                        this.active = 2;
                        this.is_finish = 2
                        this.record_id = res.data.id
                    }
                })
        },
        //支付判断
        async initPay() {
            if (this.meeting_id == 508 || this.meeting_id == 627 || this.meeting_id == 816) {
                this.checkPayStatus()
                return;
            }
            try {
                const res = await this.getWechatPayInfo();
                if (res.code != 0) return;
                this.payInfo = res.data
                console.log(this.payInfo)
                if (this.payInfo.qrcode_url) {
                    this.qrcode_url = this.payInfo.qrcode_url;
                    return;
                }
                // this.setupWechat(this.payInfo);

                if (typeof WeixinJSBridge == "undefined") {
                    if (document.addEventListener) {
                        document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                    } else if (document.attachEvent) {
                        document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                        document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                    }
                } else {
                    this.onBridgeReady();
                }
            } catch (error) {
                console.error('Error initializing WeChat Pay:', error);
            }
        },
        setupWechat(payInfo) {
            wx.config({
                debug: false,
                appId: payInfo.appId,
                timestamp: payInfo.timeStamp,
                nonceStr: payInfo.nonceStr,
                // signature: payInfo.paySign,
                jsApiList: ['chooseWXPay']
            });

            wx.ready(() => {
                this.chooseWXPay(payInfo);
            });

            wx.error((res) => {
                console.error('Config error:', res);
            });
        },
        chooseWXPay(payInfo) {
            wx.chooseWXPay({
                appId: payInfo.appId,
                timeStamp: payInfo.timeStamp,
                nonceStr: payInfo.nonceStr,
                package: payInfo.package,
                signType: payInfo.signType,
                paySign: payInfo.paySign,
                success: (res) => {
                    console.log('微信支付成功');
                    this.active == 3
                    // this.$router.replace({ name: 'fullOrder', query: { id: '2' } });
                },
                cancel: (res) => {
                    console.log('用户取消支付');
                    Toast('取消支付')

                    // this.$router.replace({ name: 'paymentCancelled' });
                },
                fail: (res) => {
                    Toast('支付失败')
                    console.error('支付失败:', res);
                }
            });
        },
        //获取订单支付信息
        async getWechatPayInfo() {
            const response = await axios.post(MeetingOrderPayment, {
                meeting_id: this.meeting_id,
                out_trade_no: this.out_trade_no,
                money: this.money,
                description: this.name

            });

            return response.data;
        },
        // 微信支付
        onBridgeReady() {
            let payInfo = this.payInfo;
            let that = this
            WeixinJSBridge.invoke('getBrandWCPayRequest', {
                appId: payInfo.appId,
                timeStamp: payInfo.timeStamp,
                nonceStr: payInfo.nonceStr,
                package: payInfo.package,
                signType: payInfo.signType,
                paySign: payInfo.paySign,
            },
                function (res) {
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                        that.checkPayStatus()
                        // 使用以上方式判断前端返回,微信团队郑重提示：
                        //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                    }
                });
        },

        //支付结果查询
        checkPayStatus() {
            if (this.meeting_id == 508 || this.meeting_id == 627 || this.meeting_id == 816 || this.qrcode_url) {
                this.active = 3
                return;
            }
            let params = {
                out_trade_no: this.out_trade_no,
                meeting_id: this.meeting_id,
                id: this.record_id
            }
            const method = "POST";
            fetch(MeetingPayCheck, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        if (res.data.status) {
                            Toast('支付成功')
                            this.active = 3

                        } else {
                            Toast('未支付')
                        }
                    }
                })
        },
        onConfirm(value) {
            this.value = value;
            this.showPicker = false;
        },
        //上传图片     
        uploadImg(file) {
            console.log(file)
            let url = MeetingUploadImg;
            // let params = {
            //     file: file.content
            // }
            const formData = new FormData();
            formData.append('file', file.file);
            const method = "POST";
            fetch(url, formData, method)
                .then((res) => {
                    if (res.code == 0) {
                        console.log('images', this.images);
                        // this.images.push({ url: res.data.path})
                        this.imageArr.push(res.data.path)
                    }
                })
        },
        deleteImg(file) {
            console.log(file);
            this.images = this.images.filter(item => item.url !== file.url)
            this.imageArr = this.imageArr.filter(item => item !== file.url)
            console.log('images', this.imageArr);

        },
        updateVoucher() {
            const url = PayInfoUpdate;
            let params = {};
            if (this.type == 2 || this.meeting_id == 508 || this.meeting_id == 627 || this.meeting_id == 816) {
                if (!this.imageArr.length) {
                    Toast('请上传支付订单截图')
                    return
                }

            }
            if (!(this.voucher_info.title && this.voucher_info.tax_number && this.voucher_info.email && this.voucher_info.mobile)) {
                Toast('请填写完整的开票信息')
                return
            }

            params = {
                meeting_id: this.meeting_id,
                title: this.voucher_info.title,
                tax_number: this.voucher_info.tax_number,
                address: this.voucher_info.address,
                bank_name: this.voucher_info.bank_name,
                bank_number: this.voucher_info.bank_number,
                email: this.voucher_info.email,
                mobile: this.voucher_info.mobile,
                reg_id: this.reg_id,
                image: this.imageArr
            }

            const method = "POST";
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        Toast('修改成功')
                        setTimeout(() => {
                            this.$router.go(-1)
                        }, 2000)
                    }
                })
        },

        //上传支付凭证/开票信息
        uploadVoucher() {
            if (this.reg_id) {
                this.updateVoucher()
                return;
            }
            const url = MeetingUploadVoucher;
            let params = {};
            if (this.type == 2 || this.meeting_id == 508 || this.meeting_id == 627 || this.meeting_id == 816) {
                if (!this.imageArr.length) {
                    Toast('请上传支付订单截图')
                    return
                }

            }
            if (!(this.voucher_info.title && this.voucher_info.tax_number && this.voucher_info.email && this.voucher_info.mobile)) {
                Toast('请填写完整的开票信息')
                return
            }
            var images = this.images.map(item => item.url)

            params = {
                meeting_id: this.meeting_id,
                title: this.voucher_info.title,
                tax_number: this.voucher_info.tax_number,
                address: this.voucher_info.address,
                bank_name: this.voucher_info.bank_name,
                bank_number: this.voucher_info.bank_number,
                email: this.voucher_info.email,
                mobile: this.voucher_info.mobile,
                id: this.record_id,
                image: this.imageArr
            }


            const method = "POST";
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        Toast('注册成功')
                        setTimeout(() => {
                            this.$router.replace({
                                path: '/VascularNews/chargeInfo/index?meeting_id=' + this.meeting_id
                            })
                        }, 2000)
                    }
                })
        }


    },

}
</script>

<style lang="scss" scoped>
.charge-register {
    padding: 15px;
    width: 100%;
    min-height: 100%;
    background: #fff;

    .steps {
        display: flex;
        align-items: center;
        justify-content: space-between;

        >div {
            padding: 0 10px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #F3F3F3;
            border-radius: 5px;
            color: #666;
            font-size: 12px;

            span {
                background: #D8D8D8;
                color: #666;
                border-radius: 50%;
                width: 16px;
                height: 16px;
                line-height: 16px;
                text-align: center;
                display: block;
                margin-right: 5px;
                font-size: 12px;
            }

            .van-icon {
                margin-right: 5px;
                font-size: 16px;
            }
        }

        .active {
            background: #FFF3F3;
            color: #0E0E0E;

            span {
                background: #901D22;
                color: #fff;
            }

            .van-icon {
                margin-right: 5px;
            }
        }

    }

    .htitle {
        display: flex;
        font-size: 18px;
        margin-bottom: 20px;
        margin-top: 30px;


        span {
            display: block;
            height: 20px;
            border-bottom: 5px solid #FFBFBF;
        }
    }

    .form {
        width: 100%;

        .van-cell-group {
            width: 100%;
            display: flex;
            flex-direction: column;

        }

        .van-cell {
            background: #F7F7F8;
            border-radius: 5px;
            margin-bottom: 10px;
            height: 45px;
            overflow: visible;

            .label {
                color: #141414;

            }

            .van-radio-group {
                display: flex;
                align-items: center;

                .van-radio {
                    margin-right: 24px;
                }
            }
        }

        .van-cell:last-child {
            height: auto;
        }
    }

    .btns {
        display: flex;
        // justify-content: space-between;
        width: 100%;
        left: 0;
        position: relative;
        margin-top: 30px;
        padding: 0;


        >div {
            width: 40%;
            height: 45px;
            color: #fff;
            background: #901D22;
            line-height: 45px;
            text-align: center;
            font-size: 16px;
            border-radius: 5px;
            flex: auto;
            margin: 0 10px;
        }

        .noEnd {
            opacity: 0.3;
        }
    }

    .bottom {
        position: absolute !important;
        bottom: 10%;
        padding: 0 15px;

    }

    .scan {
        .info {
            font-size: 13px;
            line-height: 22px;
        }

        .money {
            display: flex;
            justify-content: space-between;
            align-content: center;
            margin-top: 10px;
            margin-bottom: 15px;

            div {
                width: 165px;
                height: 40px;
                background: #F7F7F8;
                font-size: 15px;
                font-weight: 500;
                text-align: center;
                line-height: 40px;
                border-radius: 5px;
            }
        }



    }

    .pay-qrcode {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #666;

        p {
            font-size: 13px;
        }

        img {
            width: 175px;
            height: auto;
        }
    }

    .tip-msg {
        margin-top: 20px;
        font-size: 13px;
        color: #666;
        line-height: 22px;
    }

    .remit-info>div {
        display: flex;
        justify-content: space-between;
        margin-top: 15px;
    }

    .invoices {
        .van-cell::after {
            right: 0;
            left: 0;
            border-bottom: 1px solid #e8eaec;

        }

        .van-uploader__preview {
            border: 0.5px solid #D7D7D7;
            border-radius: 5px;
            overflow: hidden;
            background: rgba(0, 0, 0, 0.5);
            text-align: center;
            color: #fff;
            font-size: 16px;
        }

        .van-uploader__upload {
            background: #dcdee0;
        }

        .van-uploader__upload-icon {
            color: #f7f8fa;
        }
    }
}

.toast {
    position: fixed;
    top: 20%;
    width: 90%;
    height: 50px;
    line-height: 50px;

}

.van-uploader,
.van-uploader__preview-image {
    width: 100%;
}

.van-uploader__preview {
    width: 23%;
}

.van-uploader__preview:nth-child(4n) {
    margin-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/ChargeInfo/collectInfo.vue